import React from 'react'
import { Outlet } from 'react-router-dom'
import { Navbar } from '../NavBar'
import { AppWrapper, MainContent } from '../../GlobalStyles/AppStyles'
import { SideBar } from '../SideBar'

export const Home = () => (
  <>
    <Navbar />
    <AppWrapper id='detail'>
      <SideBar />
      <MainContent>
        <Outlet />
      </MainContent>
    </AppWrapper>
  </>
)
